import { render, staticRenderFns } from "./type-tag.vue?vue&type=template&id=c67b2892&scoped=true"
import script from "./type-tag.vue?vue&type=script&lang=js"
export * from "./type-tag.vue?vue&type=script&lang=js"
import style0 from "./type-tag.vue?vue&type=style&index=0&id=c67b2892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b2892",
  null
  
)

export default component.exports